import { CloseOutlined } from '@ant-design/icons';
import { InputNumber, Slider, Radio, Popover } from 'antd';
import usePreventDefault from '@/utils/customHooks/usePreventDefault';

import './renderParamsMore.scss';
import { useEffect, useRef, useState } from 'react';

export default function RenderParamsMore() {
    usePreventDefault();

    const marks = {
        1.5: '室外',
        5: '室内',
    };

    const [envBright, setEnvBright] = useState(3);

    const onEnvBrightChange = value => {
        console.log(value);
        setEnvBright(value);
    };

    const [envReflect, setEnvReflect] = useState(3);

    //数据blender无法还原，产品说暂时隐藏
    // const onEnvReflectChange = value => {
    //     console.log(value);
    //     setEnvReflect(value);
    // };

    const [envTone, setEnvTone] = useState('nature');

    const onEnvToneChange = e => {
        console.log(e);
        setEnvTone(e.target.value);
    };

    const [exteriorBright, setExteriorBright] = useState(1);

    const onExteriorBrightChange = value => {
        console.log(value);
        setExteriorBright(value);
    };

    const handleClose = () => {
        try {
            window.external.DispatchFun('Atlas', 'HideMoreSettingWindow', '');
        } catch (e) {}
    };

    const emitHddApi = (renderParams, renderParamsMore, params) => {
        renderParamsMore[renderParams.exterior.id] = params;

        localStorage.setItem(
            'renderParamsMore',
            JSON.stringify(renderParamsMore)
        );

        renderParams.exterior = {
            ...renderParams.exterior,
            ...params,
        };

        renderParams.lightingPlan = {
            status: 'none',
            id: '',
            name: '',
        };

        console.log('renderParams', renderParams);
        try {
            window.external.DispatchFun(
                'Atlas',
                'setRenderParams',
                JSON.stringify(renderParams)
            );
        } catch {}
    };

    const isFirst = useRef(true);
    const suppressNextMoreEmit = useRef(false);

    const [exterior, setExterior] = useState({});

    useEffect(() => {
        const SYNC_KEY = 'hddRenderExteriorSync';

        const applyExteriorSyncPayload = d => {
            if (!d || !d.exteriorId) return;
            let rp = {};
            try {
                rp =
                    JSON.parse(localStorage.getItem('renderParams') || '{}') ||
                    {};
            } catch {
                return;
            }
            if (rp.exterior?.id !== d.exteriorId) return;
            if (d.exterior) {
                setExterior(d.exterior);
            }
            if (d.envBright !== undefined && d.envBright !== null) {
                setEnvBright(d.envBright);
            }
            if (d.envReflect !== undefined && d.envReflect !== null) {
                setEnvReflect(d.envReflect);
            }
            if (d.envTone !== undefined && d.envTone !== null) {
                setEnvTone(d.envTone);
            }
            if (d.exteriorBright !== undefined && d.exteriorBright !== null) {
                setExteriorBright(d.exteriorBright);
            }
            suppressNextMoreEmit.current = true;
        };

        const onStorage = e => {
            if (e.key !== SYNC_KEY || e.newValue == null) return;
            try {
                const d = JSON.parse(e.newValue);
                applyExteriorSyncPayload(d);
            } catch {
                /* ignore */
            }
        };

        window.addEventListener('storage', onStorage);
        return () => {
            window.removeEventListener('storage', onStorage);
        };
    }, []);

    useEffect(() => {
        const renderParams = JSON.parse(localStorage.getItem('renderParams'));

        setExterior(renderParams.exterior);

        let params = {
            envBright,
            envReflect,
            envTone,
            exteriorBright,
        };

        if (localStorage.getItem('renderParamsMore')) {
            let renderParamsMore = JSON.parse(
                localStorage.getItem('renderParamsMore')
            );

            let curLocalParams = renderParamsMore[renderParams.exterior.id];

            let nextParams = curLocalParams ? curLocalParams : params;

            if (
                !curLocalParams ||
                (nextParams.envBright === 3 &&
                    nextParams.exteriorBright === 1 &&
                    nextParams.envTone === 'nature')
            ) {
                //如果没有新建过，或者新建的值和默认值一样，触发不了下面的 useEffect 需要收到调用 hdd 接口

                emitHddApi(renderParams, renderParamsMore, nextParams);
            } else {
                setEnvBright(nextParams.envBright);

                setEnvTone(nextParams.envTone);

                setExteriorBright(nextParams.exteriorBright);
            }
        } else {
            let renderParamsMore = {};

            emitHddApi(renderParams, renderParamsMore, params);
        }
    }, []);

    const envBrightTipContent = (
        <div>
            <div className="img-wrap">
                <img src={require('@/assets/img/hdd/env-low.png').default} />
                <img src={require('@/assets/img/hdd/env-high.png').default} />
            </div>
            <div className="tip-word" style={{ marginTop: '10PX' }}>
                可以调节环境光的亮度
            </div>
        </div>
    );

    const envHdrTipContent = (
        <div>
            <div className="img-wrap">
                <img src={require('@/assets/img/hdd/hdr-low.png').default} />
                <img src={require('@/assets/img/hdd/hdr-high.png').default} />
            </div>
            <div className="tip-word" style={{ marginTop: '10PX' }}>
                可以调节外景贴图的亮度
            </div>
        </div>
    );

    useEffect(() => {
        if (isFirst.current) {
            isFirst.current = false;
            return;
        }

        if (suppressNextMoreEmit.current) {
            suppressNextMoreEmit.current = false;
            return;
        }

        const params = {
            envBright,
            envReflect,
            envTone,
            exteriorBright,
        };

        const renderParams = JSON.parse(localStorage.getItem('renderParams'));

        if (!renderParams) return;

        const renderParamsMore = JSON.parse(
            localStorage.getItem('renderParamsMore')
        );

        emitHddApi(renderParams, renderParamsMore, params);
    }, [envBright, envReflect, envTone, exteriorBright]);

    return (
        <div className="render-params-more">
            <h1>
                <span>{exterior?.name}</span>
                <CloseOutlined onClick={handleClose} />
            </h1>
            <div className="setting-exterior">
                <div className="large-label">外景图</div>
                <div className="small-label">
                    亮度
                    <Popover content={envHdrTipContent} title={null}>
                        <img
                            src={require('@/assets/img/hdd/Shape.png').default}
                            className="help-tip"
                        />
                    </Popover>
                </div>
                <div className="slider-wrap">
                    <Slider
                        min={0}
                        max={10}
                        step={0.1}
                        onChange={onExteriorBrightChange}
                        value={exteriorBright}
                    />
                    <InputNumber
                        min={0}
                        max={10}
                        step={0.1}
                        value={exteriorBright}
                        onPressEnter={e => e.target.blur()}
                        onChange={onExteriorBrightChange}
                    />
                </div>
            </div>
            <div className="setting-env">
                <div className="large-label">环境光</div>
                <div className="small-label">
                    亮度
                    <Popover content={envBrightTipContent} title={null}>
                        <img
                            src={require('@/assets/img/hdd/Shape.png').default}
                            className="help-tip"
                        />
                    </Popover>
                </div>
                <div className="slider-wrap slider-env-bright">
                    <Slider
                        min={0}
                        max={20}
                        marks={marks}
                        onChange={onEnvBrightChange}
                        value={envBright}
                    />
                    <InputNumber
                        min={0}
                        max={20}
                        value={envBright}
                        onPressEnter={e => e.target.blur()}
                        onChange={onEnvBrightChange}
                    />
                </div>
                {/* <div className="small-label">
                    反射强度
                    <QuestionCircleOutlined />
                </div>
                <div className="slider-wrap">
                    <Slider
                        min={0}
                        max={20}
                        onChange={onEnvReflectChange}
                        value={envReflect}
                    />
                    <InputNumber
                        min={0}
                        max={20}
                        value={envReflect}
                        onChange={onEnvReflectChange}
                    />
                </div> */}
                <div className="small-label">色调</div>
                <Radio.Group
                    buttonStyle="solid"
                    onChange={onEnvToneChange}
                    value={envTone}>
                    <Radio.Button value="cool">冷光</Radio.Button>
                    <Radio.Button value="nature">自然光</Radio.Button>
                    <Radio.Button value="warm">暖光</Radio.Button>
                </Radio.Group>
            </div>
        </div>
    );
}
